import classNames from 'classnames';
import * as React from 'react';
import { MouseEventHandler, ReactNode } from 'react';
// tslint:disable-next-line import-blacklist
import { Href, Link as NavLink } from 'redux-little-router';

import { Bem } from '../../service/Bem/Bem';
import { LinkTarget } from '../../typings/common';

import './StyledLink.css';

export enum StyledLinkTheme {
    alert = 'alert',
    common = 'common',
    white = 'white',
    icon = 'icon',
    blue = 'blue',
    grey = 'grey',
    black = 'black'
}

export interface StyledLinkProps {
    theme?: StyledLinkTheme;
    onClick?: MouseEventHandler<{}>;
    href?: string;
    title?: string;
    cls?: string;
    target?: LinkTarget;
    disabled?: boolean;
    children: ReactNode;
}

export interface RouteStyledLinkProps {
    onClick?: () => void;
    theme?: StyledLinkTheme;
    href: Href;
    title?: string;
    cls?: string;
    target?: LinkTarget;
    disabled?: boolean;
}

export class StyledLink extends React.Component<StyledLinkProps> {
    shouldComponentUpdate(prevProps: StyledLinkProps) {
        return (
            prevProps.href !== this.props.href ||
            prevProps.title !== this.props.title ||
            prevProps.children !== this.props.children
        );
    }

    render() {
        const {
            children,
            theme = StyledLinkTheme.common,
            title,
            cls = '',
            target,
            href,
            onClick,
            disabled
        } = this.props;
        const className = classNames(
            Bem.cls({
                block: 'styled-link',
                mods: { theme }
            }),
            cls
        );

        return disabled ? (
            <span
                title={title}
                className={classNames(
                    className,
                    Bem.cls({
                        block: 'styled-link',
                        mods: {
                            disabled: Boolean(disabled)
                        }
                    })
                )}
            >
                {children}
            </span>
        ) : (
            <a {...{ title, target, href, onClick, className }}>{children}</a>
        );
    }
}

export class RouteStyledLink extends React.PureComponent<RouteStyledLinkProps, {}> {
    render() {
        const { children, theme = StyledLinkTheme.common, title, cls = '', target, href, disabled } = this.props;
        const className = classNames(
            Bem.cls({
                block: 'styled-link',
                mods: { theme }
            }),
            cls
        );

        return disabled ? (
            <span
                title={title}
                className={classNames(
                    className,
                    Bem.cls({
                        block: 'styled-link',
                        mods: { disabled: Boolean(disabled) }
                    })
                )}
            >
                {children}
            </span>
        ) : (
            <NavLink
                {...{
                    title,
                    target,
                    href,
                    className
                }}
            >
                {children}
            </NavLink>
        );
    }
}
